import { create } from "zustand";

type CookiePreferencesStore = {
  open: boolean;
  openCookiePreferences: () => void;
  closeCookiePreferences: () => void;
};

/**
 * Global cookie-preferences dialog state.
 *
 * Zustand rather than context so the footer's "Cookie settings" control and the
 * account menu can both open it without a provider wrapping either — the same
 * reason `useFeedbackDialogStore` exists. It also has to be reachable from the
 * banner, which is mounted in `__root` beside the router rather than inside it.
 *
 * The law calls for this: consent has to be as easy to withdraw as it was to
 * give, so the way back in cannot be buried behind a page navigation.
 */
export const useCookiePreferencesStore = create<CookiePreferencesStore>(
  (set) => ({
    open: false,
    openCookiePreferences: () => set({ open: true }),
    closeCookiePreferences: () => set({ open: false }),
  }),
);
